let language = {
    STORE_PRODUCT_EMPTY_STORE_DES1: "添加您的 ",
    STORE_PRODUCT_EMPTY_STORE_GO_STORE: "商店",
    STORE_PRODUCT_EMPTY_STORE_DES2: " 来开始创建产品。"
};

export { language }
